<template>
  <div id="components_base_menu" v-show="currThemeObj && currThemeObj.cssStyle">
    <div class="menu_row1">
      <span
        v-if="customizeInd === 0"
        class="companyLogo"
        @click="pageJump($router, 'platfromHomeIndex')"
      >
        <img :src="companyLogo" />
      </span>

      <!-- cctv -->
      <span
        v-if="customizeInd === 1"
        class="companyLogo cctv"
        @click="pageJump($router, 'platfromHomeIndex')"
      >
        <img :src="companyLogo" />
      </span>

      <span class="menu_project">
        <span class="topMenu_left">
          <span class="dataPosterLogo">
            <img v-if="dataPosterLogo" :src="dataPosterLogo" />
          </span>
          <!-- <span class="timeZone_switch" v-show="isShowTimeZone">
            <el-switch
              v-model="timeZoneSwitchFlag"
              :active-color="currThemeObj.cssStyle.subColor1_1"
              :inactive-color="currThemeObj.cssStyle.selectInputActColor"
              :active-text="timeZoneSwitchArr[1].name"
              :inactive-text="timeZoneSwitchArr[0].name"
              @change="timeZoneFlagChange"
            ></el-switch>
          </span> -->
        </span>
        <span class="group_user">
          <span
            class="group_area"
            @click.stop="clickShowListPop('groupAreaFlag', groupAreaFlag)"
            :class="groupAreaFlag ? 'open' : ''"
          >
            <!-- <img src="" /> -->
            <span class="name" v-text="currGroup && currGroup.groupName"></span>
            <i class="arrow_icon el-icon-arrow-down"></i>
            <span class="list_pop">
              <span
                class="list_pop_item"
                v-for="item in groupList"
                :key="item.groupId"
                v-text="item.groupName"
                :class="item.act ? 'act' : ''"
                @click="changeGroup(item)"
              ></span>
            </span>
          </span>
          <span
            class="user_area"
            @click.stop="clickShowListPop('userAreaFlag', userAreaFlag)"
            :class="userAreaFlag ? 'open' : ''"
          >
            <!-- <img src="" /> -->
            <span class="name" v-text="userInfor.userAlias"></span>
            <i class="arrow_icon el-icon-arrow-down"></i>
            <span class="list_pop">
              <span
                class="list_pop_title"
                v-text="userInfor.companyName"
              ></span>
              <span
                class="list_pop_title pb20"
                v-text="userInfor.userAlias"
              ></span>
              <span
                v-if="userInfor.station"
                class="list_pop_item"
                v-text="'后台管理工作台'"
                @click="goManageWeb"
              ></span>
              <span class="list_pop_item" v-text="'修改密码'"></span>
            </span>
          </span>
        </span>
      </span>
      <span class="menu_exit" v-text="exitTitle" @click="logout"></span>
    </div>
    <div class="menu_row2">
      <div
        v-for="(menu, menuIndex) in menuData"
        :key="menu.name"
        :class="menu.name"
      >
        <span
          v-for="item in menu.arr"
          :key="item.key"
          v-text="item.name"
          @click="clickMenu(item, menuIndex)"
          :class="[
            item.act ? 'act' : '',
            item.child ? 'hasChild' : '',
            secMenuData.arr.length > 0 && secMenuData.key.includes(item.key)
              ? 'open'
              : '',
          ]"
        ></span>
      </div>
    </div>
    <div class="menu_row3" :class="secMenuData.arr.length > 0 ? 'show' : ''">
      <span
        class="sec_menuItem"
        v-for="item in secMenuData.arr"
        :key="item.key"
        v-text="item.name"
        :class="item.act ? 'act' : ''"
        @click="clickSecMenu(item, secMenuData)"
      ></span>
    </div>
    <div
      class="select_pops"
      :class="isOpenFlag ? 'open' : ''"
      @click="openSelect(isOpenFlag)"
    >
      <div
        class="select_infor"
        :style="{ height: `${selectInforStyleHeight}vw` }"
      >
        <div class="infor_main">
          <span
            class="select_item"
            v-for="item in selectData"
            :key="item.key"
            :class="item.act ? 'act' : ''"
            @click="clickSelect(item)"
          >
            <span class="selectItem_logo">
              <img :src="item.logoImage" />
            </span>
            <span class="selectItem_name" v-text="item.name"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { https_user_logout } from '@api/platfrom_base_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import customizeProMixins_data_mixin from '@customizeProMixins/index.js'
import customizeInd from '@customizeProMixins/getCustomizeInd'
export default {
  name: 'components_base_menu',
  mixins: [cup_base_data_mixin, customizeProMixins_data_mixin],
  props: {
    selectData: {
      // 存储当前cid下面的所有赛季
      type: Array,
      default() {
        return [
          // {
          //   name: '2022卡塔尔',
          //   logoImage: '',
          //   key: '1072020', //seasonId
          //   act: true,
          // },
          // {
          //   name: '2018卡塔尔',
          //   logoImage: '',
          //   key: '1072016',
          //   act: false,
          // },
        ]
      },
    },
    groupList: {
      type: Array,
      default: () => {
        return []
      },
    },
    // currGroup: {
    //   type: Object,
    //   default: null,
    // },
    userInfor: {
      type: Object,
      default: () => ({
        companyName: '',
        email: '',
        identy: '',
        role: '',
        station: null,
        stationName: '',
        userAlias: '',
        userId: '',
      }),
    },
    timeZoneFlag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      customizeInd,
      isOpenFlag: false,
      exitTitle: '退出',
      menuSeasonName: '',
      menuData: [],
      secMenuData: {
        key: [],
        arr: [],
      },
      groupAreaFlag: false,
      userAreaFlag: false,
      initIsClickSeasonFlag: false, // 当为 true 时 ，说明 isClickSeasonFlag 已经走完判断了
      isClickSeasonFlag: false, //控制最上面切赛季是否可以点击
    }
  },
  watch: {
    $route(to, from) {
      // 如果是从b到a页面，则不缓存b
      // 注意 路由那么要与组件name一致

      console.debug(from.name, to.name)
      console.debug('route:', this.$route)
      // console.debug('currThemeObj:', this.currThemeObj)
      const pathModule = this.$route.meta.pathModule
      if (pathModule.length == 3) {
        let curMenuKey = pathModule[2]
        this.menuData.forEach((cell) => {
          cell.arr.forEach((e) => {
            if (curMenuKey == e.key) {
              e.act = true
              if (e.child) {
                e.child.forEach((child) => {
                  if (child.routeName == this.$route.name) {
                    child.act = true
                  } else {
                    child.act = false
                  }
                })
              }
            } else {
              if (e.act) {
                // 打开二级菜单，但是没有关闭就点击其他一级菜单，需要将二级菜单关闭
                this.secMenuData = {
                  key: [],
                  arr: [],
                }
              }
              if (e.child) {
                // 将其他二级菜单置为false
                e.child.forEach((child) => {
                  child.act = false
                })
              }
              e.act = false
            }
          })
        })
      }
    },
  },
  async created() {
    // this.timeZoneSwitchFlag = this.timeZoneFlag
    let { menuData, menuSeasonName, sportType } =
      await require(`./index_menuData.js`)
    this.menuData = menuData
    this.menuSeasonName = menuSeasonName
    this.sportType = sportType
    this.getUserRoleList()

    this.init()
  },
  mounted() {
    window.addEventListener('click', this.clickShowListPop)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickShowListPop)
  },
  computed: {
    companyLogo() {
      return this.currThemeObj.imageUrl
        ? require(`@src/assets/images/platfrom_${this.customizePro}/company_logo_white.png`)
        : ''
    },
    dataPosterLogo() {
      return this.currThemeObj.imageUrl
        ? require(`@src/assets/images/platfrom_${this.customizePro}/dataPoster_logo.png`)
        : ''
    },
    selectInforStyleHeight() {
      let height = 0
      if (!this.isOpenFlag) {
        return height
      }
      if (this.selectData.length > 0) {
        height = Math.ceil(this.selectData.length / 4) * 4.86 + 2.083 + 2.083
      }

      return height
    },
  },
  methods: {
    init() {
      console.debug('route:', this.$route, this.currGroup)
      console.debug('currThemeObj:', this.currThemeObj)
      const pathModule = this.$route.meta.pathModule
      console.debug('pathModule meun:', pathModule, this.menuData)
      if (pathModule.length == 3) {
        let curMenuKey = pathModule[2]
        this.menuData.forEach((cell) => {
          cell.arr.forEach((e) => {
            if (curMenuKey == e.key) {
              e.act = true
              if (e.child) {
                e.child.forEach((child) => {
                  if (child.routeName == this.$route.name) {
                    child.act = true
                  } else {
                    child.act = false
                  }
                })
              }
            } else {
              e.act = false
            }
          })
        })
      }
    },
    // timeZoneFlagChange(val) {
    //   console.debug(val)
    //   // true: 北京时区；false:当地时区
    //   this.$emit('timeZoneFlagEvent', {
    //     val,
    //     item: this.timeZoneSwitchArr[val ? 1 : 0],
    //   })
    // },
    clickShowListPop(key, flag) {
      console.debug('clickShowListPop', key, typeof key)
      const arr = ['groupAreaFlag', 'userAreaFlag']
      if (typeof key === 'string') {
        if (key == arr[0] && this[arr[1]]) {
          this[arr[1]] = false
        } else {
          this[arr[0]] = false
        }
        this[key] = !flag
      } else {
        // 点击其他地方将小组和用户菜单收起
        arr.forEach((key) => {
          if (this[key]) {
            this[key] = false
          }
        })
      }
    },
    clickMenu(item, index) {
      console.debug(item, index)

      if (item.isOpenWeb) {
        this.openNewWeb(this.$router, `${item.routeName}`)
      } else {
        if (this.secMenuData.arr.length > 0) {
          const pathModule = this.$route.meta.pathModule
          if (item.key !== this.secMenuData.key[1]) {
            // console.debug(
            //   '不同二级菜单:',
            //   item.key,
            //   this.secMenuData.key[1],
            //   pathModule
            // )
            if (this.secMenuData.key[1] != pathModule[2]) {
              // 二级菜单已展示，此时点击另一个有二级菜单的一级菜单，下面逻辑是先将上一个有二级菜单的一级菜单act=false
              let isLevelFlag = false //解决不是同一级跳转时二级菜单不会收起，比如（从报名数据点击视频锦集【有二级菜单，但不点击二级，只是展示二级菜单出来】然后点击播出单）
              this.menuData.forEach((cell, cellIndex) => {
                if (index == cellIndex) {
                  cell.arr.forEach((e) => {
                    if (this.secMenuData.key[1] == e.key) {
                      e.act = false
                      this.secMenuData = {
                        key: [],
                        arr: [],
                      }
                      isLevelFlag = true
                    }
                  })
                }
              })
              if (!isLevelFlag) {
                this.menuData.forEach((cell, cellIndex) => {
                  if (index !== cellIndex) {
                    cell.arr.forEach((e) => {
                      if (this.secMenuData.key[1] == e.key) {
                        e.act = false
                        this.secMenuData = {
                          key: [],
                          arr: [],
                        }
                        isLevelFlag = true
                      }
                    })
                  }
                })
              }
            }
          } else {
            // 只是关闭二级菜单
            this.secMenuData = {
              key: [],
              arr: [],
            }
            console.debug(item.act, index)

            if (item.act) {
              if (item.key != pathModule[2]) {
                // 如果不是在自己的页面打开二级菜单，关闭二级菜单时需要将一级菜单的选中效果去掉
                this.menuData.forEach((cell, cellIndex) => {
                  if (index == cellIndex) {
                    cell.arr.forEach((e) => {
                      if (item.key == e.key) {
                        e.act = false
                      }
                    })
                  }
                })
              }
              console.debug(item, index, pathModule)
              return
            }
          }
        }
        if (item.child && item.child.length > 0) {
          this.menuData.forEach((cell, cellIndex) => {
            if (index == cellIndex) {
              cell.arr.forEach((e) => {
                if (item.key == e.key) {
                  e.act = true
                  console.debug(cell, item.key)
                  this.secMenuData = {
                    key: [cell.key, item.key],
                    arr: item.child,
                  }
                }
              })
            }
          })
          return
        }
        this.menuData.forEach((cell, cellIndex) => {
          if (index == cellIndex) {
            // console.debug('不同二级菜单:', 111, index, item)
            cell.arr.forEach((e) => {
              if (item.key == e.key) {
                e.act = true
              } else {
                e.act = false
                if (e.child) {
                  // 将其他二级菜单置为false
                  e.child.forEach((child) => {
                    child.act = false
                  })

                  //  关闭二级菜单
                  this.secMenuData = {
                    key: [],
                    arr: [],
                  }
                }
              }
            })
          } else {
            cell.arr.forEach((e) => {
              e.act = false
              if (e.child) {
                // 将其他二级菜单置为false
                e.child.forEach((child) => {
                  child.act = false
                })
              }
            })
          }
        })
        this.pageJump(this.$router, `${item.routeName}`)
      }
    },
    openSelect(flag) {
      if (!this.isClickSeasonFlag) return
      this.isOpenFlag = !flag
    },
    clickSelect(item) {
      console.debug('clickSelect:', item)
      let currSeasonMap = JSON.parse(
        this.$localStorage.getItem('mixtmt_platfromV4_currSeasonMap')
      )
      if (!currSeasonMap) {
        currSeasonMap = {}
      }
      const fullPath = this.$route.fullPath
      console.debug('this.$route:', this.$route)
      let currCidKey = null
      if (fullPath && fullPath.indexOf('/') > -1) {
        currCidKey = fullPath.split('/')[1]

        // 合并对象
        let currCidObj = Object.assign(
          {},
          currSeasonMap[currCidKey] ? currSeasonMap[currCidKey] : {},
          {
            cid: item.cid,
            sid: item.key,
            name: item.name,
          }
        )

        currSeasonMap[currCidKey] = currCidObj
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSeasonMap',
          JSON.stringify(currSeasonMap)
        )

        this.$emit('changeSidEvent', item.key)
        const pathModule = this.$route.meta.pathModule
        if (pathModule.length == 3) {
          for (let i = 0; i < this.menuData.length; i++) {
            const cell = this.menuData[i]
            for (let j = 0; j < cell.arr.length; j++) {
              const e = cell.arr[j]

              if (e.act && e.key == pathModule[2]) {
                console.debug(
                  'changeSidToInitPageEvent:',
                  e,
                  pathModule,
                  this.$route.name
                )
                let routeName = e.routeName
                if (e.child) {
                  e.child.forEach((child) => {
                    if (child.act) {
                      routeName = child.routeName
                    }
                  })
                }
                if (
                  routeName === this.$route.name ||
                  this.$route.name.indexOf(routeName) == 0
                ) {
                  let curPageInitNum = this.curPageInitNum + 1
                  return this.$emit('changeSidToInitPageEvent', curPageInitNum)
                } else {
                  return this.$router.replace({ name: routeName })
                }
              }
            }
          }
        }
      }
    },
    clickSecMenu(item, data) {
      if (item.isOpenWeb) {
        this.openNewWeb(this.$router, `${item.routeName}`)
      } else {
        const keyArr = data.key
        this.menuData.forEach((cell) => {
          if (keyArr[0] == cell.key) {
            cell.arr.forEach((e) => {
              if (keyArr[1] == e.key) {
                e.act = true
                e.child.forEach((child) => {
                  if (item.key == child.key) {
                    child.act = true
                  } else {
                    child.act = false
                  }
                })
              } else {
                e.act = false
                if (e.child) {
                  // 将其他二级菜单置为false
                  e.child.forEach((child) => {
                    child.act = false
                  })
                }
              }
            })
          } else {
            cell.arr.forEach((e) => {
              e.act = false
              if (e.child) {
                // 将其他二级菜单置为false
                e.child.forEach((child) => {
                  child.act = false
                })
              }
            })
          }
        })
        this.secMenuData = {
          key: [],
          arr: [],
        }
        this.pageJump(this.$router, `${item.routeName}`)
      }
    },
    changeGroup(item) {
      this.$emit('changeGroupEvent', item)
    },
    goManageWeb() {
      // 新开窗口进管理端
      const isDevPro = window.mixtmt_platfrom.envOtherOption.devPro
      const url =
        window.mixtmt_platfrom.envOtherOption[isDevPro].backendManageUrl
      window.open(url)
      // window.location.href = url
    },
    async logout() {
      //退出登录
      await https_user_logout('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('退出登录')
            this.$message({
              showClose: true,
              message: '用户退出登录成功',
              type: 'success',
            })
            if (this.customizeInd === 0) {
              // 跳转到登录页
              this.$router.push({ name: 'platfromLoginIndex' })
            } else if (this.customizeInd === 1) {
              // console.debug('cctv 退出')
              // this.$router.push({ name: 'platfromLoginIndex' })
              let curLocationOrigin = window.location.origin
              setTimeout(() => {
                window.location = `${curLocationOrigin}/unification/unauth`
              }, 2 * 1000)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#components_base_menu {
  width: 100%;
  height: auto;
  background-color: var(--mixtmt_whiteColor);
  color: var(--mixtmt_whiteColor);
  box-shadow: 0.2vw 0.2vw 0.972vw 0.486vw rgba(60, 59, 59, 0.15);
  .menu_row1 {
    position: fixed;
    top: 0.416vw;
    left: 0;
    z-index: 100;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    height: 3.468vw;
    background-color: var(--mixtmt_mainColor);
    & .menu_exit {
      width: 9.722vw;
      text-align: center;
      height: 2.788vw;
      line-height: 2.788vw;
    }
    & .companyLogo {
      width: 9.722vw;
      height: 2.23vw;
      margin: 0.278vw 0;
    }
    & .companyLogo.cctv {
      width: 9.722vw;
      height: 2.788vw;
      margin: 0;
    }
    .companyLogo {
      img {
        display: block;
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }

    & .menu_project {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .topMenu_left {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .dataPosterLogo {
          width: 5.83vw;
          height: 1.388vw;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        /* .project_select {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .project_select_logo {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            width: 4.44vw;
            height: 4.3vw;
            padding: 0.416vw 0.972vw 0.416vw 0;
            background-position: top left;
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-image: url(../../../assets/images/competition_logo.png);
            & > span {
              display: block;
              height: 100%;
              width: 100%;
              background-position: top center;
              background-repeat: no-repeat;
              background-size: auto 100%;
            }
          }
          .project_select_name {
            position: relative;
            font-size: 1.11vw;
            font-weight: bold;
            &::before {
              position: absolute;
              left: 50%;
              bottom: -1.264vw;
              z-index: 2;
              margin-left: -0.6vw;
              width: 0;
              height: 0;
              border-left: 0.6vw solid transparent;
              border-right: 0.6vw solid transparent;
              border-bottom-width: 0.6vw;
              border-bottom-style: solid;
              border-bottom-color: var(--mixtmt_whiteColor);
            }
          }
          &:not(.unselect)::after {
            position: absolute;
            left: 105%;
            top: 50%;
            z-index: 2;
            content: '\20';
            transition: transform 0.3s linear;
            -webkit-transition: -webkit-transform 0.3s linear;
            margin-top: -0.35vw;
            width: 0;
            height: 0;
            border-left: 0.4vw solid transparent;
            border-right: 0.4vw solid transparent;
            border-top: 0.5vw solid var(--mixtmt_whiteColor);
          }
        }
        .project_select {
          &.open {
            .project_select_name {
              &::before {
                content: '\20';
              }
            }
            &::after {
              transform: rotate(180deg);
            }
          }
        } */
        .timeZone_switch {
          padding-left: 3.2vw;
        }
      }
      .group_user {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .user_area,
        .group_area {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 1.388vw;
          img {
            width: 1.805vw;
            height: 1.805vw;
            border-radius: 50%;
            background-color: var(--mixtmt_whiteColor);
            overflow: hidden;
          }
          .name {
            padding: 0 0.694vw;
            width: auto;
          }
          .arrow_icon {
            transition: transform 0.3s linear;
          }
          .list_pop {
            display: none;
            position: absolute;
            top: 3.052vw;
            left: 50%;
            z-index: 100;
            width: 10.416vw;
            height: auto;
            background-color: var(--mixtmt_whiteColor);
            padding: 0.972vw 0;
            transform: translateX(-50%);
            border: 1px solid var(--mixtmt_greyColor7);
            border-radius: 0.556vw;
            .list_pop_title,
            .list_pop_item {
              display: block;
              padding: 0 0.972vw;
              line-height: 2.5vw;
              font-size: 0.972vw;
              color: var(--mixtmt_greyColor3);
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              text-align: center;
              &.act {
                background-color: var(--mixtmt_greyColor8);
                color: var(--mixtmt_mainColor);
              }
            }
            .list_pop_title {
              color: var(--mixtmt_greyColor2);
            }
            .mb20 {
              margin-bottom: 2.083vw;
            }
            .pb20 {
              padding-bottom: 2.083vw;
            }
          }
          &.open {
            .arrow_icon {
              transform: rotate(180deg);
            }
            .list_pop {
              display: block;
            }
          }
        }
      }
    }
  }
  & .menu_row2 {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 3.884vw;
    height: 4.116vw;
    font-size: 1.111vw;
    font-weight: bold;
    padding: 1.388vw 9.722vw 0;
    color: var(--mixtmt_greyColor2);
    .webMenu,
    .openMenu {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      span {
        position: relative;
        margin: 0 1.736vw;
        width: auto;
        &.act {
          color: var(--mixtmt_blackColor);
          &::before {
            left: 0;
            right: 0;
            background-color: var(--mixtmt_compBase_menu_row2ActColor);
          }
        }
        &.hasChild::after {
          position: absolute;
          left: 110%;
          top: 50%;
          z-index: 2;
          content: '\20';
          transition: transform 0.3s linear;
          -webkit-transition: -webkit-transform 0.3s linear;
          margin-top: -0.2vw;
          width: 0;
          height: 0;
          border-left: 0.4vw solid transparent;
          border-right: 0.4vw solid transparent;
          border-top: 0.5vw solid var(--mixtmt_greyColor6);
        }
      }
    }
    .webMenu {
      position: relative;

      span {
        &:first-child {
          margin: 0 1.736vw 0 0;
        }
        &:last-child {
          margin: 0 3.472vw 0 1.736vw;
        }
        &.open {
          &::after {
            transform: rotate(180deg);
          }
        }
        &::before {
          content: '\20';
          position: absolute;
          bottom: -20%;
          left: 51%;
          right: 51%;
          z-index: 2;
          height: 0.208vw;
          /* width: 100%; */
          border-radius: 0.104vw;
          background-color: var(--mixtmt_compBase_menu_row2ActColor);
          -webkit-transition-property: left, right;
          transition-property: left, right;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          -webkit-transition-timing-function: ease-out;
          transition-timing-function: ease-out;
        }
      }
    }
    .openMenu {
      position: relative;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        height: 100%;
        width: 1px;
        background-color: var(--mixtmt_greyColor0);
      }
      span {
        &:first-child {
          margin: 0 1.736vw 0 3.472vw;
        }
        &::before {
          content: '\20';
          position: absolute;
          bottom: -20%;
          left: 51%;
          right: 51%;
          z-index: 2;
          height: 0.208vw;
          /* width: 100%; */
          border-radius: 0.104vw;
          background-color: var(--mixtmt_compBase_menu_row2ActColor);
          -webkit-transition-property: left, right;
          transition-property: left, right;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          -webkit-transition-timing-function: ease-out;
          transition-timing-function: ease-out;
        }
      }
    }
  }
  & .menu_row3 {
    display: none;
    justify-content: flex-start;
    align-items: flex-start;
    height: 4.116vw;
    font-weight: bold;
    padding: 1.388vw 9.722vw 0;
    color: var(--mixtmt_whiteColor);
    background: linear-gradient(
      135deg,
      var(--mixtmt_theme_cascaderSelectPop_1_2) 0%,
      var(--mixtmt_theme_cascaderSelectPop_1_1) 100%
    );
    &.show {
      display: flex;
      display: -webkit-flex;
    }
    .sec_menuItem {
      padding: 0 2.083vw;
      font-size: 0.972vw;
      &.act {
        color: var(--mixtmt_whiteColor);
        text-decoration: underline;
      }
      &:first-child {
        padding: 0 2.083vw 0 0;
      }
    }
  }

  .select_pops {
    position: fixed;
    top: 3.884vw;
    left: 0;
    z-index: 1600;
    width: 100%;
    height: 0;
    background-color: var(--mixtmt_greyColor4);

    &.open {
      height: 100%;
      .select_infor {
        height: 10vw;
        max-height: 60%;
        transition: height 0.3s ease-in;
      }
    }
    .select_infor {
      width: 100%;
      padding: 0 9.722vw;
      height: 0;
      overflow: auto;

      .infor_main {
        width: 100%;
        padding: 2.083vw;
        background-color: var(--mixtmt_whiteColor);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 0 0 0.6vw 0.6vw;
        .select_item {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 20%;
          height: 4.86vw;
          color: var(--mixtmt_greyColor3);
          &.act {
            text-decoration: underline;
          }
          .selectItem_logo {
            width: 2.083vw;
            height: 2.083vw;
            /* background-color: rgba(216, 216, 216, 1); */
            border-radius: 0.347vw;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .selectItem_name {
            width: calc(100% - 2.083vw);
            padding: 0 0.556vw;
            font-size: 1.11vw;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.mixtmt_pc #components_base_menu {
  .menu_row1 {
    .companyLogo {
      &:hover {
        cursor: pointer;
      }
      /* &.cctv:hover {
          cursor: default;
        } */
    }
    .menu_project {
      .topMenu_left {
        .project_select {
          &:not(.unselect) {
            &.open,
            &:hover {
              cursor: pointer;
              color: var(--mixtmt_greyColor0);
              &::after {
                border-top-color: var(--mixtmt_greyColor0);
              }
            }
          }
        }
      }
      .group_user {
        .user_area,
        .group_area {
          cursor: pointer;
          &:hover {
            color: var(--mixtmt_greyColor0);
            .list_pop {
              .list_pop_title {
                &:hover {
                  cursor: default;
                }
              }
              .list_pop_item {
                &:hover {
                  background-color: var(--mixtmt_greyColor8);
                  color: var(--mixtmt_mainColor);
                  cursor: pointer;
                }
              }
            }
          }
        }
        .user_area.open {
          .list_pop {
            &:hover {
              cursor: default;
            }
          }
        }
      }
    }
    .menu_exit {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_greyColor0);
      }
    }
  }
  & .menu_row2 {
    span:hover {
      color: var(--mixtmt_blackColor);
      cursor: pointer;
      &::before {
        bottom: -20%;
        left: 0;
        right: 0;
        background-color: var(--mixtmt_compBase_menu_row2ActColor);
      }
    }
  }

  & .menu_row3 {
    .sec_menuItem {
      cursor: pointer;
      &:hover {
        color: var(--mixtmt_whiteColor);
        text-decoration: underline;
      }
    }
  }

  & .select_pops {
    .select_infor {
      .infor_main {
        .select_item {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

.mixtmt_ipad #components_base_menu {
  .menu_row2 {
    padding: 0.972vw 3vw 0;
  }
}
</style>

<style lang="scss">
#components_base_menu {
  .menu_row1 {
    & .menu_project {
      .topMenu_left {
        .timeZone_switch {
          .el-switch {
            font-size: 0.972vw;
            line-height: 1.38vw;
            height: 1.38vw;
            .el-switch__label--left,
            .el-switch__label--right {
              margin-right: 0.416vw;
            }
            .el-switch__label--right {
              margin-left: 0.416vw;
            }
            .el-switch__label {
              height: 1.38vw;
              font-size: 0.972vw;
              color: rgba(255, 255, 255, 0.4);
              &.is-active {
                color: #fff;
              }
              & * {
                font-size: 0.972vw;
              }
            }
            &.is-checked {
              .el-switch__core {
                &::after {
                  left: 100%;
                  margin-left: calc(-1.1vw - 1px);
                }
              }
            }
            .el-switch__core {
              margin: 0;
              position: relative;
              width: 2.778vw !important;
              height: 1.38vw;
              border: 1px solid #dcdfe6;
              outline: 0;
              border-radius: 0.694vw;
              &::after {
                content: '';
                position: absolute;
                top: 1px;
                left: 1px;
                width: 1.1vw;
                height: 1.1vw;
                background-color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
